<div
    [class]="setStyleFlag() ? 'bg-primary' : 'bg-white'"
    class="relative px-4 py-3 flex w-full justify-between gap-2.5 rounded-xl"
>
    @if (!completenessError()) {
        @if (open()) {
            <app-chat-tooltip
                animate.leave="fade-out"
                (close)="open.set(false)"
                class="absolute bottom-[calc(100%+12px)]"
            >
                기존 아동이 등록되어있지 않은 경우 '아동 신규 등록'을
                진행해주세요
            </app-chat-tooltip>
        }
    }

    @if (!open() && completenessError() === "2") {
        <app-chat-tooltip
            disableClose
            animate.leave="fade-out"
            class="absolute bottom-[calc(100%+12px)]"
        >
            아동을 먼저 등록해주세요
        </app-chat-tooltip>
    }
    <div class="flex gap-2.5 items-center">
        <p
            [class]="setStyleFlag() ? 'text-white' : 'text-gray-800'"
            [class.!text-gray-400]="completeness()?.createChild"
            class="lg:text-base text-sm"
        >
            아동 등록
        </p>
        @if (completeness()?.createChild) {
            <div class="badge bg-gray-400">완료</div>
        } @else {
            <div
                [class]="
                    setStyleFlag()
                        ? 'bg-white !text-gray-800'
                        : 'text-white bg-primary'
                "
                class="badge"
            >
                등록 필요
            </div>
        }
    </div>
    <div
        routerLink="/child/find"
        class="flex gap-2 items-center cursor-pointer"
    >
        <p
            [class]="setStyleFlag() ? 'text-white' : 'text-gray-400 '"
            class="text-sm lg:block hidden"
        >
            @if (completeness()?.createChild) {
                등록완료
            } @else {
                등록하기
            }
        </p>
        <app-icon
            name="material-symbols:arrow-forward-ios"
            class="!size-3.5 text-gray-300"
        />
    </div>
</div>
